/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpErrorResponse, HttpResponse, HttpStatusCode } from '@angular/common/http';
import { skipAutoDateConversion, parseDateTime } from '../../../api-dates';
import { Observable, of, throwError } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageDataDto as FeatureMailingListsPageDataDto } from '../../models/feature/mailing-lists/page-data-dto';

export interface GetPageData$Params {
  id: number;
}

export function getPageData(http: HttpClient, rootUrl: string, params: GetPageData$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureMailingListsPageDataDto | undefined>> {
  const rb = new RequestBuilder(rootUrl, getPageData.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r.clone({ body: reviveResponseBody(r.body) }) as StrictHttpResponse<FeatureMailingListsPageDataDto | undefined>;
    }),
    catchError((e: unknown) => {
      if (e instanceof HttpErrorResponse && e.status === HttpStatusCode.NotFound) {
        const response = new HttpResponse({ status: e.status, statusText: e.statusText, headers: e.headers, url: e.url ?? undefined });
        // HttpResponse turns an undefined body into null
        return of(Object.assign(response, { body: undefined }) as StrictHttpResponse<FeatureMailingListsPageDataDto | undefined>);
      }
      return throwError(() => e);
    })
  );
}

getPageData.PATH = '/edit-mailing-list-page/data/{id}';

function reviveFeatureMailingListsPageDataDto(value: any): any {
  if (value) {
    if (value["suppressions"]) {
      for (let i0 = 0; i0 < value["suppressions"].length; i0++) {
        if (value["suppressions"][i0] != null) {
          value["suppressions"][i0] = reviveFeatureMailingListsSuppressionDto(value["suppressions"][i0]);
        }
      }
    }
  }
  return value;
}

function reviveFeatureMailingListsSuppressionDto(value: any): any {
  if (value) {
    if (value["addedAt"] != null) {
      value["addedAt"] = parseDateTime(value["addedAt"]);
    }
  }
  return value;
}

function reviveResponseBody(body: any): any {
  if (body != null) {
    body = reviveFeatureMailingListsPageDataDto(body);
  }
  return body;
}
